// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__2ZVJh","summary":"CartItem_summary__iK1tJ","price":"CartItem_price__qViI7","amount":"CartItem_amount__1IEbJ","actions":"CartItem_actions__a0-D3"};